import React, { useState } from 'react'
import {
  CheckContainer,
  ContentWrapper,
  AccordionCheckWrapper,
  CheckInput,
  AccordionCheckLabel,
  Title,
  Text,
  AccordionWrapper,
  AccordionButton,
  AccordionContent,
} from './style'

const ChecAccordionItem = ({ item, index }) => {
  const { title, content, accordionHint, accordionContent, toggleChecked } =
    item
  const [checked, setChecked] = useState(false)
  const [openAccordion, setOpenAccordion] = useState(false)
  function handleToggle() {
    setChecked(!checked)
  }
  function toggleAccordion() {
    setOpenAccordion(!openAccordion)
  }
  return (
    <CheckContainer>
      <ContentWrapper>
        <AccordionCheckWrapper name="checkbox button">
          <CheckInput
            type="checkbox"
            name="checkbox"
            id={`${title}-${index}`}
            aria-checked={checked ? true : false}
            checked={checked}
            onClick={() => handleToggle()}
            onChange={toggleChecked(title, checked)}
          />
          <AccordionCheckLabel htmlFor={`${title}-${index}`}>
            <Title>{title}</Title>
            <Text>{content}</Text>
          </AccordionCheckLabel>
        </AccordionCheckWrapper>
        <AccordionWrapper role="accordion">
          <AccordionContent
            aria-hidden={!openAccordion}
            id={`accordion-content-${index}`}
          >
            {accordionContent}
          </AccordionContent>
          <AccordionButton
            onClick={() => toggleAccordion()}
            aria-expanded={openAccordion}
            aria-controls={`accordion-content-${index}`}
            aria-describedby={`see more about ${title}`}
            name={openAccordion ? 'accordion expanded' : 'accordion'}
          >
            {openAccordion
              ? 'See less'
              : accordionHint
              ? accordionHint
              : 'See more'}
          </AccordionButton>
        </AccordionWrapper>
      </ContentWrapper>
    </CheckContainer>
  )
}

export default ChecAccordionItem
